import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const USER_API = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class HomepageVideoService {

  constructor(private http:HttpClient) { }

  getAllHomePageVideosData(query) {
    return this.http.get(`${USER_API}homepagevideo${query}`);
  }

  getHomePageVideoWebsiteList(query) {
    return this.http.get(`${USER_API}homepagevideo/V1?${query}`);
  }

  getHomePageVideoById(id:string) {
    return this.http.get(`${USER_API}homepagevideo/${id}`);
  }

  addHomePageVideo(homePageVideoData) {
    return this.http.post(`${USER_API}homepagevideo`,homePageVideoData);
  }

  updateHomePageVideo(id,updatedhomePageVideoData) {
    return this.http.put(`${USER_API}homepagevideo/${id}`,updatedhomePageVideoData);
  }
}
